import { usePermission } from "@/utils/hooks/usePermisson";
import { useEffect } from "react";
import HBConfirm from "../HBModal/confirm";

export default function GdPermission({
  code,
  children,
  withConfirm,
  fallback = null,
}: {
  code: string;
  children: JSX.Element;
  withConfirm?: boolean;
  fallback?: JSX.Element;
}) {
  const hasPermission = usePermission(code);

  // 没有权限时，弹窗提示
  useEffect(() => {
    if (withConfirm && !hasPermission) {
      HBConfirm.open({
        title: "权限不足",
        content: "您没有权限访问该内容",
      });
    }
  }, [hasPermission, withConfirm]);

  if (hasPermission) return children;

  return fallback;
}
